module.exports = __webpack_public_path__ + "static/media/no-items.36f3b5d0.svg";